import { createStore } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';

// @ts-ignore
import reduxReset from 'redux-reset';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Compressor
import createCompressor from './transform-persists';
import { reconcileReadable } from './reconcileReadable';

// Reducers
import rootReducer from './reducers';

// Actions
import { CLEAN_STATE } from './actions/main';



// INTEGRACIÓN 9: actionTabs en blacklist para que no se persista
// El estado de tabs debe determinarse por el flujo (creación/validación), no por localStorage
// orderCloseConfirmation: no persistir para evitar que el modal reaparezca en navegaciones
const blacklist = ['modal', 'actionTabs', 'orderCloseConfirmation', 'tabs'];
const compressor = createCompressor({ blacklist });

const persistConfig = {
  timeout: null,
  key: 'root',
  storage: storage,
  blacklist,
  transforms: [compressor],
  // Un trozo ilegible se queda con su estado inicial en vez de `null`
  // (ver `reconcileReadable`). Antes era `autoMergeLevel1` a secas.
  stateReconciler: reconcileReadable,
};


// @ts-ignore
const persistedReducer = persistReducer(persistConfig, rootReducer);

const composeEnhancer = [reduxReset(CLEAN_STATE)];

export const store = createStore(
  persistedReducer,
  composeWithDevTools(...composeEnhancer)
);
export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
